// ServicesPage.js
import React, { useState, useEffect } from 'react';
import { 
    Box, TextField, Button, IconButton, Modal,Checkbox,
    Typography, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
  } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SearchIcon from '@mui/icons-material/Search';
import LockResetIcon from '@mui/icons-material/LockReset';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Container } from '@mui/material';
import DataTable from 'react-data-table-component';
import { ServicioService } from '../../services/servicioService';
import { layoutService } from '../../services/layoutService';
import { toast, ToastContainer } from 'react-toastify';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Editor } from '@tinymce/tinymce-react';


const ServicesPage = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [selectedService, setSelectedService] = useState(null);
    const [serviceToDelete, setServiceToDelete] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isModalLayoutOpen, setIsModalLayoutOpen] = useState(false)

    const [name, setName] = useState('');
    const [businessLine, setBusinessLine] = useState('');
    const [subject, setSubject] = useState('');
    const [minamount, setMinAmount] = useState('')

    const [layoutId, setLayoutId] = useState('');
    const [layoutStatusId, setLayoutStatusId] = useState('');
    const [layoutName, setLayoutName] = useState('');
    const [layoutHTML, setLayoutHTML] = useState('');
    
    const [isPercent, setIsPercent] = useState(false);
    const [isMax, setIsMax] = useState(false);
    const [isMin, setIsMin] = useState(false);

    useEffect(() => {
        fetchServices();
      }, []);

    const today = new Date();

    const getStatusText = (idStatus) => {
        return idStatus === 1 ? 'Activo' : 'Inactivo';
    };

    const fetchServices = async () => {
        try {
          setLoading(true);
          const data = await ServicioService.getAllServicio();
          setServices(data);
          setLoading(false);
        } catch (err) {
          setError('Error al cargar los roles');
          setLoading(false);
        }
      };

    const handleViewDetail = (service) => {
        setSelectedService(service);
        setIsDetailModalOpen(true);
    };

    const handleEdit = (service) => {
        setSelectedService(service);    
        setName(service.name);
        setBusinessLine(service.idBusiness);
        setSubject(service.subject);
        setMinAmount(service.minAmount);
        setIsModalOpen(true);
    };

    const handleDelete = (service) => {
      setServiceToDelete(service);
      setIsDeleteDialogOpen(true);
    };

    const handleEditLayout = async (service) => {
      setSelectedService(service);
      var layout = await layoutService.getLayoutByServiceId(service.id);
      setLayoutHTML(layout.layoutContent);  
      setLayoutId(layout.id);
      setLayoutName(layout.layoutName);

      setIsModalLayoutOpen(true);
    }

    const handleChangePercent = (event) => {
      setIsPercent(event.target.checked);
    };

    const handleChangeMax = (event) => {
      setIsMax(event.target.checked);
    };

    const handleChangeMin = (event) => {
      setIsMin(event.target.checked);
    };

    const handleSaveLayoutItem = () => {
      
    }

    const handleEditorChange = (content) => {
      setLayoutHTML(content);  
    };

    const handleAdd = () => {
        setSelectedService(null);
        setName('');
        setBusinessLine('');
        setSubject('');
        setMinAmount('');
        setIsModalOpen(true);
    };

    const handleSaveService = async () => {
        var serviceDTO = {
          name,
          businessLine,
          subject,
          minamount
        }
        try {
          if (selectedService) {
            await ServicioService.editServicio(selectedService.id, serviceDTO);
          } else {
            await ServicioService.createServicio(serviceDTO);
          }
          setIsModalOpen(false);
          fetchServices();
          toast.success('Servicio guardado con éxito');
        } catch (err) {
          setError('Error al guardar el servicio');
        }
      };

      const confirmDelete = async () => {
        await ServicioService.deleteServicio(serviceToDelete.id)
        fetchServices();
        setIsDeleteDialogOpen(false);
      };
    
    

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => row.name,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Linea de Negocio',
            selector: row => row.businessLine,
            sortable: true,
        },
        {
            name: 'Estado',
            selector: row => getStatusText(row.idStatus),
            sortable: true,
            cell: row => (
            <span className={`apple-badge ${row.idStatus === 1 ? 'apple-badge-success' : 'apple-badge-error'}`}>
                {getStatusText(row.idStatus)}
            </span>
            ),
        },
        {
            name: 'Monto Minimo',
            selector: row => row.minAmount,
            sortable: true,
        },
        {
            name: 'Acciones',
            cell: row => (
            <Box>
                <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
                <VisibilityIcon fontSize="small" />
                <span className="tooltiptext">Ver Detalle</span>
                </IconButton>
                <IconButton onClick={() => handleEditLayout(row)} size="small" className="apple-button apple-tooltip">
                <EditNoteIcon fontSize="small" />
                <span className="tooltiptext">Editar layout</span>
                </IconButton>
                <IconButton onClick={() => handleEdit(row)} size="small" className="apple-button apple-tooltip">
                <EditIcon fontSize="small" />
                <span className="tooltiptext">Editar</span>
                </IconButton>
                <IconButton onClick={() => handleDelete(row)} size="small" className="apple-button apple-tooltip">
                <RemoveCircleOutlineIcon fontSize="small" color='error'/>
                <span className="tooltiptext">Desactivar</span>
                </IconButton>
            </Box>
            ),
            width: '200px',
        },
    ];

    const customStyles = {
        table: {
          style: {
            minWidth: '100%',
          },
        },
        headRow: {
          style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
          },
        },
        headCells: {
          style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
          },
        },
        cells: {
          style: {
            fontSize: '14px',
            color: '#1D1D1F',
          },
        },
    };

    const filteredItems = services.filter(
      item => (item.subject && item.subject.toLowerCase().includes(filterText.toLowerCase())) ||
              (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
    );

    const subHeaderComponentMemo = React.useMemo(() => {
        return (
          <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
            <div className="apple-search-container">
              <SearchIcon className="apple-search-icon" />
              <input
                type="text"
                placeholder="Buscar por nombre"
                onChange={e => setFilterText(e.target.value)}
                className="apple-search-input"
              />
            </div>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAdd}
              className="apple-button"
            >
              Agregar Servicio
            </Button>
          </Box>
        );
      }, [filterText]);

    return (
        <div className="apple-container">
        <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
        </Paper>


        <Modal
        open={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
        }}>
          <Typography id="modal-modal-title" className="apple-modal-title">
            Detalles del Servicio
          </Typography>
          <div className="apple-modal-content">
            <TextField
              label="ID" fullWidth
              value={selectedService?.id}
              margin="normal"
              InputProps={{readOnly: true,}}
            />
            <TextField
              label="Nombre"
              fullWidth
              value={selectedService?.name}
              margin="normal"
              InputProps={{ readOnly: true,}}
            />
            <TextField
              label="Línea de Negocio"
              fullWidth
              value={selectedService?.businessLine}
              margin="normal"
              InputProps={{readOnly: true,}}
            />
            <TextField
              label="Monto mínimo"
              fullWidth
              value={selectedService?.minAmount}
              margin="normal"
              InputProps={{readOnly: true,}}
            />
            <TextField
              label="Estado"
              fullWidth
              value={getStatusText(selectedService?.idStatus)}
              margin="normal"
              InputProps={{readOnly: true,}}
            />
            <TextField
              label="Fecha de Creación"
              fullWidth
              value={new Date(selectedService?.createAt).toLocaleString()}
              margin="normal"
              InputProps={{readOnly: true,}}
            />

            </div>
          <div className="apple-modal-footer">
            <Button onClick={() => setIsDetailModalOpen(false)} className="apple-button">
              Cerrar
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
         <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
        }}>
          <Typography id="modal-modal-title" className="apple-modal-title">
            {selectedService ? 'Editar Servicio' : 'Agregar Nuevo Servicio'}
          </Typography>
          <div className="apple-modal-content">
            <TextField
              label="Nombre"
              variant="outlined"
              fullWidth
              className="apple-input"
              defaultValue={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              label="Linea de Negocio"
              variant="outlined"
              fullWidth
              className="apple-input"
              defaultValue={businessLine}
              onChange={(e) => setBusinessLine(e.target.value)}
            />
            <TextField
              label="Descripción"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              className="apple-input"
              defaultValue={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
            <div className="modal-content" style={{ display: 'flex', flexDirection:'row', gap: '16px', width:'100%'}}>
              <TextField
                label="Monto Mínimo"
                variant="outlined"
                fullWidth
                className="apple-input"
                defaultValue={minamount}
                onChange={(e) => setMinAmount(e.target.value)}
              />
              <FormControlLabel control={<Checkbox checked={isPercent} onChange={handleChangePercent}/>} label="Porcentaje" />
              <FormControlLabel control={<Checkbox checked={isMax} onChange={handleChangeMax}/>} label="Máximo" />
              <FormControlLabel control={<Checkbox checked={isMin} onChange={handleChangeMin} />} label="Mínimo" />
            </div>
             
            
          </div>
          <div className="apple-modal-footer">
            <Button onClick={() => setIsModalOpen(false)} className="apple-button">
              Cancelar
            </Button>
            <Button variant="contained" className="apple-button" onClick={() => handleSaveService()}>
              {selectedService ? 'Guardar Cambios' : 'Crear Servicio'}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={isModalLayoutOpen}
        onClose={() => setIsModalLayoutOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
      <Box
        className="custom-modal"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2">
          {selectedService ? 'Editar Layout' : 'Agregar Nuevo Layout'}
        </Typography>
        <div className="modal-content" style={{ display: 'flex', flexDirection:'row', gap: '16px', width:'100%'}}>
          <TextField
            style={{width:'200px'}}
            label="Id"
            variant="outlined"
            margin="normal"
            value={layoutId}
            onChange={(e) => setLayoutId(e.target.value)}
          />
          <TextField
            style={{width:'100%'}}
            label="Nombre"
            variant="outlined"
            margin="normal"
            value={layoutName}
            onChange={(e) => setLayoutName(e.target.value)}
          />
          <TextField
            style={{width:'60%'}}
            label="Status ID"
            variant="outlined"
            margin="normal"
            value={layoutStatusId}
            onChange={(e) => setLayoutStatusId(e.target.value)}
          />
        </div>
          <Typography variant="subtitle1" style={{ marginTop: 16 }}>
            Layout HTML
          </Typography>
          <Editor
            apiKey="no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf"
            value={layoutHTML}
            onEditorChange={handleEditorChange}
            init={{
              height: 500,
              menubar: true,
              plugins: [
                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
              ],
              toolbar: 'undo redo | blocks | ' +
                'bold italic forecolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
            }}
          />
        <div className="modal-footer" style={{ marginTop: 24, textAlign: 'right' }}>
          <Button onClick={() => setIsModalLayoutOpen(false)} style={{ marginRight: 8 }}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => handleSaveLayoutItem()}
          >
            {selectedService ? 'Guardar Cambios' : 'Crear Item'}
          </Button>
        </div>
      </Box>
    </Modal>
        {/* Diálogo de confirmación para eliminar */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro de que desea desactivar este rol?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteDialogOpen(false)} className="apple-button">Cancelar</Button>
          <Button onClick={confirmDelete} className="apple-button" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <footer >
        <p>© {today.getFullYear()} Generador de Contratos. Todos los derechos reservados Grupo Defensa. Desarrollado por Gerencia IT </p>
      </footer>
        </div>

    );
};

export default ServicesPage;